import { Search, X } from 'lucide-react'

export default function PlayerSearchInput({ value, onChange, placeholder = 'Search players or groups...' }) {
  return (
    <div style={{ position: 'relative' }}>
      <Search
        size={18}
        style={{
          position: 'absolute',
          left: '0.875rem',
          top: '50%',
          transform: 'translateY(-50%)',
          color: 'var(--text-muted)',
          pointerEvents: 'none',
        }}
      />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        style={{
          width: '100%',
          height: '44px',
          paddingLeft: '2.75rem',
          paddingRight: value ? '2.5rem' : '0.875rem',
          borderRadius: '0.5rem',
          fontSize: '0.875rem',
          backgroundColor: 'var(--bg-secondary)',
          border: '1px solid var(--border-color)',
          color: 'var(--text-primary)',
        }}
      />
      {value && (
        <button
          onClick={() => onChange('')}
          style={{
            position: 'absolute',
            right: '0.625rem',
            top: '50%',
            transform: 'translateY(-50%)',
            color: 'var(--text-muted)',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <X size={16} />
        </button>
      )}
    </div>
  )
}
